<template>
  <div v-bind="$attrs">
    <div
      :class="['section-header',
               { 'section-header--two-columns': hasTwoColumnsHeader,
                 'section-header--columns-delimiter': hasColumnsDelimiter,
                 'section-header--big-image': hasBigImage,
                 'gap-16': $slots.control && !hasTwoColumnsHeader
               }]"
      v-if="$slots.control || title"
    >
      <Heading
        :icon="icon"
        :image="image"
        :style="`minWidth: ${headingWidth}`"
        class="heading"
        kind="h2"
        type="h2"
        v-if="title"
      >
        {{ title }}
        <span
          class="heading-description"
          v-if="description"
        >
          {{ description }}
        </span>
      </Heading>
      <template
        v-if="$slots.control"
      >
        <div class="section-header__control">
          <slot
            name="control"
          />
        </div>
      </template>
    </div>
    <div :class="{'col-layout-two': twoColLayout, 'section-content--with-border': withBorder, [customClass]: customClass}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customClass: String,
    description: String,
    icon: String,
    image: String,
    hasTwoColumnsHeader: {
      type: Boolean,
      default: false,
    },
    headingWidth: String,
    title: {
      type: String,
      required: false,
    },
    twoColLayout: {
      type: Boolean,
    },
    hasColumnsDelimiter: {
      type: Boolean,
      default: false,
    },
    hasBigImage: {
      type: Boolean,
      default: false,
    },
    withBorder: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .section-header {
    display: flex;
    align-items: center;
    column-gap: 16px;

    @media only screen and (max-width: $--sm - 1px) {
      flex-direction: column;
      align-items: flex-start;
    }

    .new-form-enabled & {
      margin-bottom: rem(40px);

      h2 {
        font-weight: 600;
        margin-bottom: 0;
        margin-top: 0;
      }

      @include media('<sm') {
        margin-top: rem(20px);
        margin-bottom: rem(20px);

        h2 {
          padding-left: rem(35px);
        }
      }
    }
  }

  .section-header--big-image,
  .new-form-enabled .section-header--big-image {
    margin-bottom: rem(40px);

    :deep() {
      .heading-with-image {
        padding-left: 64px;
        font-weight: 600;
        margin-bottom: 0;
        margin-top: 0;

        img {
          width: 48px;
        }

        @media only screen and (max-width: $--breakpoint-sm - 1) {
          margin-top: rem(24px);
        }
      }
    }
  }

  .section-header__control {
    margin-left: auto;
    width: 33%;
    text-align: right;

    @media only screen and (width <= 600px) {
      width: 100%;
    }
  }

  .section-header--two-columns {
    align-items: flex-start;
    gap: 24px;

    .heading {
      flex-shrink: 0;
    }

    .section-header__control {
      flex: 1 1 100%;
      text-align: left;
      width: auto;
    }

    @media only screen and (max-width: $--sm - 1px) {
      flex-wrap: wrap;

      .section-header__control {
        margin-left: 0;
        width: 100%;
      }
    }
  }

  .section-header--columns-delimiter {
    .section-header__control {
      border-left: 1px solid $--border-color-base;
      padding-left: 24px;
    }

    @media only screen and (max-width: $--sm - 1px) {
      .section-header__control {
        border-left: unset;
        padding-left: 0;
      }
    }
  }

  .col-layout-two {
    @include media('>md') {
      display: grid;
      grid-template-rows: repeat(5, auto);
      grid-template-columns: repeat(2, 1fr);
      grid-auto-flow: column;
      gap: 0 68px;

      .sk & {
        grid-template-rows: repeat(6, auto);
      }
    }
  }

  .heading-description {
    color: $--color-text-blue;
    display: block;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    padding-top: 3px;
  }

  .el-form-item--lg {
    :deep() {
      .el-form-item {
        margin-bottom: 2.678rem;
      }
    }
  }

  .el-form-item--md {
    :deep() {
      .el-form-item {
        margin-bottom: rem(32px);
      }
    }
  }

  .section-content--with-border {
    background-color: $--color-white;
    border-radius: 12px;
    padding: 32px 24px;
    border: 1px solid $--border-color-base;

    @media only screen and (max-width: $--sm - 1px) {
      padding: 24px 16px;
    }
  }
</style>
